
import req from '../utils/request.js'
import config from '../utils/config.js'

const authreq = {}

// 后台获取token方式 PC前端此接口不用
authreq.loginwithPhonecode = function(params) {
  return new Promise((resolve, reject) => {
    req.post('/ha-base/token', params).then(res => {
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

// 手机号验证码登录（个人登录团体登录公用）
authreq.loginWithPhoneCode = function(params) {
  return new Promise((resolve, reject) => {
    req.get('/ha-base/captcha/smsCheck', params).then(res => {
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

// 暂时不用此接口
authreq.getphonecode = function(params) {
  return new Promise((resolve, reject) => {
    req.get('/ha-base/captcha/sms', params).then(res => {
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

// 微信登录
authreq.loginwithwechat = function(params) {
  return new Promise((resolve, reject) => {
    req.get('/ha-base/pc/apiv1/home/wxcallback', params).then(res => {
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

// 微信绑定
authreq.bindwx = function(params) {
  return new Promise((resolve, reject) => {
    req.get('/ha-base/user/wxcallback', params).then(res => {
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

// 获取用户扫描微信code获取用户信息
authreq.getuserbycode = function(params) {
  return new Promise((resolve, reject) => {
    req.get(config.profile.host + '/api/wechatcode', params).then(res => {
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

// 滑块验证
authreq.sliderCheck = function(params) {
  return new Promise((resolve, reject) => {
    req.post('/ha-base/captcha/imageCheck', params).then(res => {
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

// 绑定手机号
authreq.bindPhone = function(params) {
  return new Promise((resolve, reject) => {
    req.post('/ha-base/captcha/imageCheck', params).then(res => {
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

// 读者证认证
authreq.readerAuth = function(params) {
  return new Promise((resolve, reject) => {
    req.postdata('/adks-app/readersaccount/authentication', params).then(res => {
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

// 校友认证
authreq.schoolAuth = function(params) {
  return new Promise((resolve, reject) => {
    req.postdata('/adks-app/alumnus/authentication', params).then(res => {
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

// 用户详情
authreq.userInfo = function(params) {
  return new Promise((resolve, reject) => {
    req.get('/ha-base/user/info', params).then(res => {
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}
// 获取客户端配置
authreq.homeTenant = function(params) {
  return new Promise((resolve, reject) => {
    req.get('/ha-base/pc/apiv1/home/tenant', params).then(res => {
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}
export default authreq
